module.exports = __webpack_public_path__ + "static/img/1958_05_01_TownHall_Flyer_2.9ea4998.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cage/archive/1958_05_01_TownHall_Flyer_2.jpg
// module id = oc76
// module chunks = 0